import * as _ from "lodash";

export const TIME_LENGTH = 10;
export const TIME_MAX = parseInt(_.repeat("z", TIME_LENGTH), 36); // 3.656.158.440.062.975 // 11. Jan 117.829
export const SEED_LENGTH = 10;
export const SEED_MAX = parseInt(_.repeat("z", SEED_LENGTH), 36); // 3.656.158.440.062.975
export const INCR_LENGTH = 2;
export const INCR_MAX = parseInt(_.repeat("z", INCR_LENGTH), 36); // 1.295

export class FpId {
	private static incr = Math.floor(Math.random() * INCR_MAX);

	private static _seed: number = 0; // TODO:
	public static get seed() { return this._seed; }
	public static set seed(value: number) {
		if (value < 0 || value > SEED_MAX) {
			throw new Error(`value must be between 0 and ${SEED_MAX} (inclusive)`);
		}
		this._seed = value;
	}

	public static new(): string {
		if (FpId.seed == null) {
			throw new Error("seed is not set, it must be set before generating new IDs");
		}

		if (FpId.incr > INCR_MAX) {
			FpId.incr = 0;
		}

		const time = (+new Date()).toString(36);
		const seed = (FpId.seed).toString(36);
		const incr = (FpId.incr++).toString(36);

		return _.padStart(time, TIME_LENGTH, "0")
			+ "_" + _.padStart(seed, SEED_LENGTH, "0")
			+ "_" + _.padStart(incr, INCR_LENGTH, "0");
	}
}



// WEBPACK FOOTER //
// ./src/lib/FpId.ts